import PropTypes from 'prop-types';

export const THEME_PROP_TYPE = PropTypes.object;
